import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Candidates|History|Audit';
const sharedProps: Pick<LocDef, 'htmlAllowed' | 'shared' | 'feature' | 'portal'> = {
	htmlAllowed: false,
	shared: false,
	feature: HubFeature.OtherRequirementUploadCandidateAccessAudits,
	portal: 'SP',
};

type SPCandidateHistoryDetailLoc = 'SPCandidateHistoryNoData';

export const spCandidateHistoryDetailLocs: LocDefs<SPCandidateHistoryDetailLoc> = {
	SPCandidateHistoryNoData: {
		defaultValue: 'No audits selected',
		description: 'Message to display when no audits are selected.',
		displayPath: `${dpRoot}|No Data`,
		displayType: 'Content',
		...sharedProps,
	},
};

export const spCandidateHistoryDetailLocKeys = MapLocKeys<SPCandidateHistoryDetailLoc>(
	spCandidateHistoryDetailLocs
);
export type SPCandidateHistoryDetailLocKeys = typeof spCandidateHistoryDetailLocKeys;
